function prependRoot(root, prop) {
    return root ? `${root}.${prop}` : prop;
}

function encode(val, root) {
    if (val == null) {
        return '';
    }

    if (typeof val === 'string') {
        return prependRoot(root, val);
    }

    if (val instanceof Array) {
        return val
            .map(v => encode(v, root))
            .join(',');
    }

    if (val instanceof Object) {
        return Object.keys(val)
            .map(prop => encode(val[prop], prependRoot(root, prop)))
            .join(',');
    }
}

export function parse(obj) {
    if (obj == null) {
        return;
    }

    return ['fields', 'fieldsX']
        .filter(prop => obj[prop] != null)
        .map(prop => `${prop}=${encode(obj[prop])}`)
        .join('&');
}
